<div class="funnel-shell">
  <!-- Global Health is English-only — no language switcher in the funnel. -->
  <div class="funnel-shell__content">
    <ng-content />
  </div>

  <div class="funnel-shell__legal">
    <a class="funnel-shell__legal-link" (click)="openPolicy('privacy')">
      {{ 'policy.privacy' | translate }}
    </a>
    <a class="funnel-shell__legal-link" (click)="openPolicy('terms')">
      {{ 'policy.tos' | translate }}
    </a>
    <a class="funnel-shell__legal-link" (click)="openPolicy('imprint')">
      {{ 'policy.legalNotice' | translate }}
    </a>
  </div>

  @if (footerText(); as footerText) {
    <div class="funnel-shell__operator">
      <span [innerHtml]="footerText | safeHtml"></span>
    </div>
  }
</div>

<c-offcanvas
  placement="end"
  [visible]="policyVisible()"
  (visibleChange)="policyVisibleChange($event)"
>
  <c-offcanvas-header>
    <button
      type="button"
      class="btn-close ms-auto"
      aria-label="Close"
      (click)="closePolicy()"
    ></button>
  </c-offcanvas-header>
  <c-offcanvas-body>
    @if (policyLoading()) {
      <p>Loading…</p>
    } @else {
      <consent [content]="policyContent()"></consent>
    }
  </c-offcanvas-body>
</c-offcanvas>
